module.exports = __webpack_public_path__ + "img/w19-b3.98ca55a2.jpg";